(function () {
  const LOGOUT_HREF = '/account/logout';
  const LOGOUT_CLASS = 'mtc-logout-link';
  const SVG_NS = 'http://www.w3.org/2000/svg';

  function buildLogoutSvg(svgClass) {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', svgClass);

    const path1 = document.createElementNS(SVG_NS, 'path');
    path1.setAttribute('d', 'M9.75 3c-1.243 0-2.25 1.007-2.25 2.25 0 .414.336.75.75.75s.75-.336.75-.75.336-.75.75-.75h3.5c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.414 0-.75-.336-.75-.75s-.336-.75-.75-.75-.75.336-.75.75c0 1.243 1.007 2.25 2.25 2.25h3.5c1.519 0 2.75-1.231 2.75-2.75v-8.5c0-1.519-1.231-2.75-2.75-2.75h-3.5Z');

    const path2 = document.createElementNS(SVG_NS, 'path');
    path2.setAttribute('d', 'M12.25 10.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-5.69l.97-.97c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-2.25 2.25c-.141.14-.22.331-.22.53s.079.39.22.53l2.25 2.25c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-.97-.97h5.69Z');

    svg.appendChild(path1);
    svg.appendChild(path2);
    return svg;
  }

  function injectLogout(shadowRoot) {
    if (shadowRoot.querySelector('.' + LOGOUT_CLASS)) return;

    const nav = shadowRoot.querySelector('nav');
    if (!nav) return;

    const existingLink = nav.querySelector('a');
    const a = document.createElement('a');
    a.href = LOGOUT_HREF;

    if (existingLink) a.className = existingLink.className;
    a.classList.add(LOGOUT_CLASS);

    const existingSvg = existingLink && existingLink.querySelector('svg');
    const svgClass = existingSvg ? existingSvg.getAttribute('class') : 'icon tracking';

    a.appendChild(buildLogoutSvg(svgClass));
    a.appendChild(document.createTextNode('Log out'));

    nav.appendChild(a);
  }

  function watchShadowRoot(el) {
    const root = el.shadowRoot;
    if (!root) return;

    injectLogout(root);

    new MutationObserver(() => injectLogout(root))
      .observe(root, { subtree: true, childList: true });
  }

  function init() {
    const el = document.querySelector('shopify-account');
    if (!el) return;

    if (el.shadowRoot) {
      watchShadowRoot(el);
    } else {
      new MutationObserver(function (_, obs) {
        if (el.shadowRoot) {
          obs.disconnect();
          watchShadowRoot(el);
        }
      }).observe(el, { childList: true });
    }
  }

  if (customElements.get('shopify-account')) {
    init();
  } else {
    customElements.whenDefined('shopify-account').then(init);
  }
})();